import { Component, ElementRef, ViewChild } from "@angular/core";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import Swal from "sweetalert2";
import {
  Mantenimiento,
  MantenimientoService,
} from "../../../../shared/services/mantenimientos.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TipoMantenimientoService } from "../../../../shared/services/tipo_mantenimiento.service";
import { EmpresasService } from "../../../../shared/services/empresas.service";
import { FormaPagoService } from "../../../../shared/services/forma_pago.service";
import { TipoAccionService } from "../../../../shared/services/tipo_accion.service";
import { ServicioRealizadoService } from "../../../../shared/services/servicio_realizado.service";
import { SistemaMantenimientoService } from "../../../../shared/services/sistema_mantenimiento.service";
import { ParteMantenimientoService } from "../../../../shared/services/parte_mantenimiento.service";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
import { Propietario } from "../../../../shared/model/propietario";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AdministracionService } from "../../../../shared/services/administracion.services";

export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}

@Component({
  selector: "app-listado-mantenimientos",
  templateUrl: "./listado-mantenimientos.component.html",
  styleUrls: ["./listado-mantenimientos.component.scss"],
})
export class ListadoMantenimientosComponent {
  @ViewChild("inputSistema") inputSistema!: ElementRef;
  @ViewChild("inputParte") inputParte!: ElementRef;
  @ViewChild("inputTipo") inputTipo!: ElementRef;

  vehiculos: any[] = [];
  resultadosMantenimientos: Mantenimiento[] = [];
  resultadoCompleto: any;
  formMantenimiento!: FormGroup;
  filteredTableItems!: Mantenimiento[];
  mostrarTabla: boolean = false;
  mensajeBusqueda!: string;
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  public searchText: string = ""; // Texto de búsqueda
  mantenimientoSeleccionado: any;
  editMode!: boolean;
  editModeServicio!: boolean;
  TipoMantenimiento: any;
  empresaTaller: any;
  conductor: Propietario[] = [];
  formapago: any;
  servicioSeleccionado: any;
  formServicio!: FormGroup;
  modalServicioRef: any;
  validate!: boolean;
  servicios: any;
  tipoaccion: any;
  servicioRealizado: any;
  sistemaMantenimiento: any;
  parteMantenimiento!: any[];
  valorFormateado!: string;
  hoy: string = "";
  minFechaFinal: string = "";
  cargando: boolean = false;
  mostrandoToast: boolean = false;
  toastTipo: 'cargando' | 'success' | 'error' = 'cargando';
  mensajeToast: string = '';
  vehiculo: any = [];
  nombreConductor!: string;
  administraciones: Administracion[] = [];
   altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;

  estadisticasMantenimientos = {
  cantidadMantenimientos: 0,
  cantidadVehiculos: 0,
  costoTotal: 0,
  costoPromedio: 0
};
  constructor(
    private vehiclesService: VehiclesService,
    private mantenimientoService: MantenimientoService,
    private tipoMantenimientosService: TipoMantenimientoService,
    private empresasService: EmpresasService,
    private forma_pagoService: FormaPagoService,
    private tipo_accionService: TipoAccionService,
    private servicio_realizadoService: ServicioRealizadoService,
    private sistema_mantenimientoService: SistemaMantenimientoService,
    private parte_mantenimientoService: ParteMantenimientoService,
    private propietariosService: PropietarioService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private gpcGoogle: gpcGoogleService,
    private administracionesServices: AdministracionService
  ) { }

  ngOnInit() {
    this.cargarVehiculos();
    this.cargarDataAdmin();
    this.formServicio = this.fb.group({
      sistema: [null],
      parte: [null],
      tipo_de_mantenimiento: [null],
    });

    this.formMantenimiento = this.fb.group({
      fecha: [null, [Validators.required]],
      placa: [[], [Validators.required, noEspaciosEnBlanco()]],
      km: [null, [Validators.required]],
      tipo: [null, [Validators.required]],
      taller: [null, [Validators.required]],
      servicio: [null, [Validators.required]],
      accion: [null, [Validators.required]],
      factura: [null, [Validators.required, noEspaciosEnBlanco()]],
      vrpagos: [null, [Validators.required]],
      forma: [null, [Validators.required]],
      conductor: [null, [Validators.required]],
      observacion: [null],
      fechaFinal: [null],
    });

    const hoyDate = new Date();
    this.hoy = this.formatoFecha(hoyDate);

    //carga unica para el form de edicion
    this.cargarTiposMantenimiento();
    this.cargarTaller();
    this.cargarConductor();
    this.cargarForma_pago();
    this.cargarTipo_accion();
    this.cargarServicio_realizado();
    this.cargarSistema_mantenimiento();
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacas().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }

  private cargarTiposMantenimiento(): void {
    this.tipoMantenimientosService.getTipos().subscribe({
      next: (data) => (this.TipoMantenimiento = data),
      error: (error) =>
        console.error("❌ Error al obtener el mantenimiento:", error),
    });
  }

  private cargarTaller(): void {
    this.empresasService.getTaller().subscribe({
      next: (data) => (this.empresaTaller = data),
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarConductor(): void {
    this.propietariosService.getConductores().subscribe({
      next: (data) => (this.conductor = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarForma_pago(): void {
    this.forma_pagoService.getFormasPago().subscribe({
      next: (data) => (this.formapago = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarTipo_accion(): void {
    this.tipo_accionService.getAll().subscribe({
      next: (data) => (this.tipoaccion = data.data), // ✅ solo el array
      error: (error) =>
        console.error("❌ Error al obtener tipo de acción:", error),
    });
  }

  private cargarServicio_realizado(): void {
    this.servicio_realizadoService.getAll().subscribe({
      next: (data) => (this.servicioRealizado = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarSistema_mantenimiento(): void {
    this.sistema_mantenimientoService.getAll().subscribe({
      next: (data) => (this.sistemaMantenimiento = data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarParte_mantenimiento(): void {
    this.parte_mantenimientoService.getAll().subscribe({
      next: (data) => (this.parteMantenimiento = data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

buscarMantenimientos(): void {

  const {
    placa,
    fecha,
    fechaFinal
  } = this.formMantenimiento.getRawValue();

  // =====================================================
  // 1. NORMALIZAR PLACAS
  // =====================================================

  const placas: string[] = Array.isArray(placa)
    ? placa
        .filter(Boolean)
        .map((p: string) => p.trim().toUpperCase())
    : [];

  // =====================================================
  // 2. NORMALIZAR FECHAS
  // =====================================================

  const fechaInicial = fecha?.trim() || '';
  const fechaFin = fechaFinal?.trim() || '';

  // =====================================================
  // 3. VALIDAR FECHAS
  // =====================================================

  if (!fechaInicial) {
    this.mostrarAlerta(
      'Campo requerido',
      'Por favor, selecciona la fecha inicial',
      'info'
    );
    return;
  }

  if (!fechaFin) {
    this.mostrarAlerta(
      'Campo requerido',
      'Por favor, selecciona la fecha final',
      'info'
    );
    return;
  }

  // =====================================================
  // 4. VALIDAR RANGO
  // =====================================================

  if (fechaInicial > fechaFin) {
    this.mostrarAlerta(
      'Rango de fechas inválido',
      'La fecha inicial no puede ser mayor que la fecha final',
      'info'
    );
    return;
  }

  // =====================================================
  // 5. LIMPIAR RESULTADOS ANTERIORES
  // =====================================================

  this.resultadosMantenimientos = [];
  this.filteredTableItems = [];
  this.mensajeBusqueda = '';
  this.mostrarTabla = false;

  // =====================================================
  // 6. ACTIVAR LOADING
  // =====================================================

  this.cargando = true;

  // =====================================================
  // 7. CONSULTAR
  // =====================================================

  this.mantenimientoService
    .buscarMantenimientosPorFiltros(
      placas,
      fechaInicial,
      fechaFin
    )
    .subscribe({

      next: (resp) => {
       // console.log("✅ Respuesta de búsqueda de mantenimientos:", resp);
      const mantenimientos = (resp?.vehiculos ?? [])
    .flatMap((vehiculo: any) => vehiculo.mantenimientos ?? []);
  this.resultadoCompleto = resp;
  this.resultadosMantenimientos = mantenimientos;
  //console.log("Mantenimientos obtenidos:", this.resultadosMantenimientos);
  this.filteredTableItems = [...mantenimientos];

  // Estadísticas calculadas por el BACKEND
  this.estadisticasMantenimientos = {
    cantidadMantenimientos: resp?.cantidadMantenimientos ?? 0,
    cantidadVehiculos: resp?.cantidadVehiculos ?? 0,
    costoTotal: resp?.costoTotal ?? 0,
    costoPromedio: resp?.costoPromedio ?? 0
  };

  this.mensajeBusqueda = resp?.mensaje ?? '';
  this.mostrarTabla = true;
  this.cargando = false;
      },

      error: (err) => {

        console.error(
          '❌ Error al buscar mantenimientos:',
          err
        );

        this.resultadosMantenimientos = [];
        this.filteredTableItems = [];

        this.mensajeBusqueda =
          err?.error?.mensaje ||
          'Ocurrió un error al buscar mantenimientos.';

        this.mostrarTabla = true;
        this.cargando = false;
      }
    });
}

  filterData() {
    const search = this.searchText?.toLowerCase() || "";

    if (!search) {
      this.filteredTableItems = [...this.resultadosMantenimientos]; // Usar resultados reales
      return;
    }

    this.filteredTableItems = this.resultadosMantenimientos.filter(
      (item) =>
        item.placa?.toLowerCase().includes(search) ||
        item.fecha?.toLowerCase().includes(search) ||
        item.taller?.toLowerCase().includes(search) ||
        item.servicio?.toLowerCase().includes(search) ||
        item.accion?.toLowerCase().includes(search) ||
        item.factura?.toLowerCase().includes(search) ||
        item.forma?.toLowerCase().includes(search)
    );

    this.page1 = 1;
  }

  actualizarEstadoAInactivo(id: number, placa: string): void {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el mantenimiento con id: ${id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.mantenimientoService.inactivar(id).subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "¡Mantenimiento inactivado!",
              text: "El estado del mantenimiento ha sido actualizado correctamente.",
              confirmButtonText: "Aceptar",
            });

            // ✅ Actualizar localmente sin borrar otros elementos
            const index = this.resultadosMantenimientos.findIndex(m => m.id === id);
            if (index !== -1) {
              this.resultadosMantenimientos[index] = {
                ...this.resultadosMantenimientos[index],
                estado: 0 // o el valor que represente inactivo
              };
            }

            const indexFiltered = this.filteredTableItems.findIndex(m => m.id === id);
            if (indexFiltered !== -1) {
              this.filteredTableItems[indexFiltered] = {
                ...this.filteredTableItems[indexFiltered],
                estado: 0
              };
            }

            this.cerrarModalYRecargar();
          },

          error: (error) => {
            const mensaje =
              error?.error?.message || "No se pudo inactivar el mantenimiento.";

            Swal.fire({
              icon: "error",
              title: "Error",
              text: mensaje,
              confirmButtonText: "Aceptar",
            });

            console.error("Error al inactivar mantenimiento:", error);
          },
        });
      }
    });
  }

  private cerrarModalYRecargar() {
    this.modalService.dismissAll(); // Cierra el modal
    this.buscarMantenimientos(); // Recarga las tarjetas para la placa actual
  }

  openModalMantenimiento(content: any, id: number): void {
  this.editMode = true;

 // console.log('Abriendo modal para mantenimiento con ID:', id);

  this.mantenimientoService.getById(id).subscribe({
    next: (mantenimientoData: any) => {

   
      this.mantenimientoSeleccionado = mantenimientoData;

      // Nombre conductor
      const c = mantenimientoData.conductorNombre;

      if (c) {
        this.nombreConductor = [
          c.primernombre,
          c.segundonombre,
          c.papellidos,
          c.seapellidos
        ]
          .filter(Boolean)
          .join(' ')
          .replace(/\s+/g, ' ')
          .trim();
      } else {
        this.nombreConductor = 'Sin asignar';
      }

      console.log(mantenimientoData.formaPago?.id);
      // Cargar formulario
      this.formMantenimiento.patchValue({
        ...mantenimientoData,

        conductor: mantenimientoData.conductor
          ? Number(mantenimientoData.conductor)
          : null,

        forma: mantenimientoData.formaPago?.id ?? null,
        tipo: mantenimientoData.tipoMantenimiento?.id ?? null,
        accion: mantenimientoData.tipoAccion?.id ?? null,
        servicio: mantenimientoData.tipoServicio?.id ?? null,
        sistema: mantenimientoData.sistema?.id ?? null,
      });

   
      this.modalService.open(content, {
        size: 'xl',
        backdrop: 'static'
      });
    },

    error: (error) => {

      console.error('Error obteniendo mantenimiento:', error);

      Swal.fire({
        icon: 'error',
        title: 'No encontrado',
        text: `No se encontró un mantenimiento con ID ${id}.`
      });
    }
  });
}

  guardarMantenimiento() {
    if (this.formMantenimiento.invalid) {
      Swal.fire({
        icon: "error",
        title: "Formulario inválido",
        text: "Por favor, completa todos los campos correctamente.",
      });
      return;
    }

    const datos = {
      ...this.formMantenimiento.value,
      usuario: "admin", // Puedes cambiar esto si lo manejas por sesión
    };

    if (this.editMode && this.mantenimientoSeleccionado) {
      const datosSinCambios =
        JSON.stringify(this.mantenimientoSeleccionado) ===
        JSON.stringify(datos);

      if (datosSinCambios) {
        Swal.fire({
          icon: "info",
          title: "Sin cambios",
          text: "No se han realizado modificaciones.",
        });
        return;
      }

      this.mantenimientoService
        .editar(this.mantenimientoSeleccionado.id!, datos)
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: "Actualización exitosa",
              text: "El mantenimiento fue actualizado correctamente.",
            });

            // ✅ Actualiza solo el mantenimiento editado en la tabla
            const index = this.resultadosMantenimientos.findIndex(
              (m) => m.id === this.mantenimientoSeleccionado!.id
            );
            if (index !== -1) {
              this.resultadosMantenimientos[index] = {
                ...this.resultadosMantenimientos[index],
                ...datos,
                id: this.mantenimientoSeleccionado!.id, // asegurar ID
              };
            }

            // También actualiza en tabla filtrada si la usas
            const indexFiltered = this.filteredTableItems.findIndex(
              (m) => m.id === this.mantenimientoSeleccionado!.id
            );
            if (indexFiltered !== -1) {
              this.filteredTableItems[indexFiltered] = {
                ...this.filteredTableItems[indexFiltered],
                ...datos,
                id: this.mantenimientoSeleccionado!.id,
              };
            }

            this.modalService.dismissAll(); // 👈 cerrar modal
          },
          error: (err) => {
            this.mostrarError(err, "Error al actualizar el mantenimiento");
          },
        });
    }
  }

  private mostrarError(err: any, titulo: string) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: err.error?.message || "Ocurrió un error inesperado.",
    });
  }

  openModalServicioRealizado(content: any, servicio?: any): void {
    if (servicio) {
      this.editModeServicio = true;
      this.servicioSeleccionado = servicio;
      this.formServicio.patchValue(servicio); // Cargar datos para editar
    } else {
      this.editModeServicio = false;
      this.formServicio.reset(); // Nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalServicioRef = modalRef;
  }

  guardarServicio(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formServicio.value };

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
        {
          campo: "sistema",
          mensaje: "Por favor, ingresa el sistema",
          ref: this.inputSistema,
        },
        {
          campo: "parte",
          mensaje: "Por favor, ingresa la parte",
          ref: this.inputParte,
        },
        {
          campo: "tipo_de_mantenimiento",
          mensaje: "Selecciona un tipo de mantenimiento",
          ref: this.inputTipo,
        },
      ];

    for (const { campo, mensaje, ref } of camposObligatorios) {
      if (!this.formServicio.get(campo)?.value) {
        this.mostrarAlerta("Campo requerido", mensaje, "info");
        ref?.nativeElement.focus();
        return;
      }
    }

    datos.estado = 1; // Activado por defecto

    this.servicio_realizadoService.create(datos).subscribe({
      next: (servicioCreado) => {
        modalRef.close();

        this.servicio_realizadoService.getAll().subscribe({
          next: (data) => {
            this.servicios = data;
            this.servicioSeleccionado = servicioCreado.id;
            this.cargarServicio_realizado();
          },
          error: (err) => {
            console.error("Error al actualizar lista de servicios:", err);
          },
        });

        Swal.fire("Éxito", "Servicio registrado correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar el servicio", "error");
      },
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
      Swal.fire({
        title: titulo,
        text: mensaje,
        icon: icono,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar"   // 👉 aquí defines el texto del botón
      });
  }

  formatearYGuardarValor(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valorSinFormato = input.value.replace(/\D/g, "");
    const valorNumerico = parseInt(valorSinFormato || "0", 10);
    this.formMantenimiento.get("vrpagos")?.setValue(valorNumerico);
    this.valorFormateado = new Intl.NumberFormat("es-CO").format(valorNumerico);
  }

  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  actualizarMinFechaFinal(): void {
    const fechaInicialStr = this.formMantenimiento.get("fecha")?.value;

    if (fechaInicialStr) {
      const fechaInicial = new Date(fechaInicialStr);
      const fechaFinal = new Date(fechaInicial);
      fechaFinal.setDate(fechaFinal.getDate() + 1); // suma 1 día

      // Formato local: yyyy-MM-dd
      this.minFechaFinal = [
        fechaFinal.getFullYear(),
        String(fechaFinal.getMonth() + 1).padStart(2, "0"),
        String(fechaFinal.getDate()).padStart(2, "0"),
      ].join("-");

      const fechaFinalControl = this.formMantenimiento.get("fechaFinal");
      if (
        fechaFinalControl?.value &&
        fechaFinalControl.value < this.minFechaFinal
      ) {
        fechaFinalControl.setValue("");
      }
    }
  }

  formatoFecha(fecha: Date): string {
    const fechaColombia = fecha.toLocaleDateString("es-CO", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const [dia, mes, anio] = fechaColombia.split("/");
    return `${anio}-${mes}-${dia}`; // Formato YYYY-MM-DD
  }
  // ✅ Resta días exactos a una fecha
  restarDias(fecha: Date, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - dias);
    return nuevaFecha;
  }
  // ✅ Selecciona el rango dinámicamente según el botón presionado
  seleccionarRango(
    rango: "dia" | "semana" | "mes" | "trimestre" | "semestre" | "anio"
  ): void {
    const hoy = new Date(); // 📅 Fecha actual
    let diasARestar = 0;

    switch (rango) {
      case "dia":
        diasARestar = 1;
        break;
      case "semana":
        diasARestar = 7;
        break;
      case "mes":
        diasARestar = 30;
        break;
      case "trimestre":
        diasARestar = 90;
        break;
      case "semestre":
        diasARestar = 180;
        break;
      case "anio":
        diasARestar = 365;
        break;
    }

    const fechaInicio = this.restarDias(hoy, diasARestar);
    const fechaInicioStr = this.formatoFecha(fechaInicio);
    const fechaFinStr = this.formatoFecha(hoy);

    this.minFechaFinal = fechaInicioStr;

    this.formMantenimiento.patchValue({
      fecha: fechaInicioStr,
      fechaFinal: fechaFinStr,
    });
  }


   addHeader(doc: jsPDF,title:string) {
      const pageWidth = 216;       // Ancho total en mm (Letter)
      const marginLeft = 5;       // Margen izquierdo deseado
      const marginRight = 5;      // Margen derecho igual para simetría
      const rectY = 3;            // Distancia desde la parte superior
      const headerHeight = 20;     // Altura del encabezado
      const rectWidth = pageWidth - marginLeft - marginRight;
  
      // Dibujar el rectángulo del encabezado
      doc.setDrawColor(0, 0, 0);   // Borde negro
      doc.setLineWidth(0.5);       // Grosor del borde
      doc.rect(marginLeft, rectY, rectWidth, headerHeight);
  
      // Título centrado dentro del rectángulo
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
  
      const text = title;
      const centerX = marginLeft + rectWidth / 2;
      const textY = rectY + 12; // Ajuste vertical para ubicar el texto dentro del rectángulo
  
      doc.text(text, centerX, textY, { align: "center" });
    }
 async addHeaderImages(
     doc: jsPDF,
     gpcGoogle: any,
     imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>
   ) {
     const getSignedUrlSafe = async (path: string) => {
       try {
         const res = await gpcGoogle.getSignedUrl(path).toPromise();
         return res?.url || null;
       } catch {
         return null;
       }
     };
 
     const getImageBase64Safe = async (url: string | null) => {
       if (!url) return null;
       try {
         return await gpcGoogle.getImageBase64(url);
       } catch {
         return null;
       }
     };
 
     const imageKeys = Object.entries(imageMap);
     const signedUrls = await Promise.all(
       imageKeys.map(([_, img]) => getSignedUrlSafe(img.path))
     );
 
     const base64Images = await Promise.all(
       signedUrls.map((url) => getImageBase64Safe(url))
     );
 
     base64Images.forEach((base64, idx) => {
       const { x, y, w, h } = imageKeys[idx][1];
       if (base64) {
         doc.addImage(base64, "JPG", x, y, w, h, undefined, "FAST");
       } else {
         // Mostrar texto si no se pudo cargar la imagen
         doc.setFontSize(10);
         doc.setTextColor(100);
         doc.text("SIN SOPORTE CARGADO", x + 2, y + h / 2, { maxWidth: w });
       }
     });
   }

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const fechaHora = `${fecha} - ${hora}`;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100);

    doc.textWithLink(
      "Generado desde Admin SEAF – INDESOFT SAS",
      110,
      pageHeight - 12,
      {
         url: "https://indesoftsas.com",
        align: "center",
      }
    );

    doc.text(fechaHora, 10, pageHeight - 5);
    doc.text(`Página ${currentPage} de ${totalPages}`, 205, pageHeight - 5, {
      align: "right",
    });
  }

  // ✅ Genera un PDF de mantenimientos para un vehículo específico - jjan 04/09/2026
// ✅ Genera un PDF general de mantenimientos para varios vehículos
// jjan 04/09/2026
async generarPDFMantenimientos(resultado: any): Promise<void> {

  this.toastTipo = 'cargando';
  this.mensajeToast = 'Generando documento...';
  this.mostrandoToast = true;

  try {

  const vehiculos = Array.isArray(resultado?.vehiculos)
    ? resultado.vehiculos.filter(
        (v: any) =>
          Array.isArray(v?.mantenimientos) &&
          v.mantenimientos.length > 0
      )
    : [];


    
  if (!vehiculos.length) {

    this.mostrarAlerta(
      "Advertencia",
      "No hay mantenimientos para exportar",
      "warning"
    );

    return;
  }


  // =========================================================
  // CREAR DOCUMENTO
  // =========================================================

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "letter",
    compress: true,
  });


  const margenX = 5;

  let y = 30;


  // =========================================================
  // FUNCIÓN PARA ENCABEZADO GENERAL
  // =========================================================

  const dibujarEncabezadoGeneral = async () => {

    this.addHeader(
      doc,
      "FICHA GENERAL DE MANTENIMIENTOS"
    );


    try {

      await this.addHeaderImages(
        doc,
        this.gpcGoogle,
        {

          supertransporte: {
            path: "ministerio/supertransporte.png",
            x: 170,
            y: 7,
            w: 35,
            h: 12,
          },

          logo: {
            path:
              `${this.administraciones[0]?.nit ?? "admin"}/logos/logo.png`,

            x: this.posicionX,
            y: this.posicionY,
            w: this.ancho,
            h: this.altura,
          }

        }
      );

    } catch (error) {

      console.warn(
        "No se pudieron cargar imágenes del encabezado:",
        error
      );
    }
  };


  // =========================================================
  // ENCABEZADO PRIMERA PÁGINA
  // =========================================================

  await dibujarEncabezadoGeneral();


  // =========================================================
  // VEHÍCULOS
  // =========================================================

  for (
    let i = 0;
    i < vehiculos.length;
    i++
  ) {

    const vehiculo =
      vehiculos[i];

    const mantenimientos =
      vehiculo?.mantenimientos ?? [];
 const tiposMantenimiento =
      vehiculo?.tiposMantenimiento ?? [];
   

    if (!mantenimientos.length) {
      continue;
    }


    // =======================================================
    // CADA VEHÍCULO EN NUEVA PÁGINA
    // =======================================================

    if (i > 0) {

      doc.addPage();

      y = 30;

      await dibujarEncabezadoGeneral();
    }


    // =======================================================
    // DATOS DEL VEHÍCULO
    // =======================================================

    const altoTituloVehiculo = 8;


    doc.setLineWidth(0.3);

    doc.setFillColor(
      240,
      240,
      240
    );

    doc.setDrawColor(
      180,
      180,
      180
    );


    doc.rect(
      margenX,
      y - 5,
      206,
      altoTituloVehiculo,
      "FD"
    );


    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(9);

    doc.setTextColor(
      0,
      0,
      0
    );


    doc.text(
      "DATOS DEL VEHÍCULO",
      108,
      y,
      {
        align: "center"
      }
    );


    y += 6;


    // =======================================================
    // INFORMACIÓN VEHÍCULO
    // =======================================================

    const infoVehiculo = [

      [
        "PLACA:",
        vehiculo.placa ?? "N/A"
      ],

      [
        "EMPRESA:",
        vehiculo.empresa ?? "N/A"
      ],

      [
        "MARCA:",
        vehiculo.marca ?? "N/A"
      ],

      [
        "CLASE:",
        vehiculo.clase ?? "N/A"
      ],

      [
        "MODELO:",
        vehiculo.modelo ?? "N/A"
      ],

      [
        "CAPACIDAD:",
        vehiculo.capacidad ?? "N/A"
      ],

      [
        "COLOR:",
        vehiculo.color ?? "N/A"
      ],

      [
        "LÍNEA:",
        vehiculo.linea ?? "N/A"
      ],

      [
        "CARROCERIA:",
        vehiculo.carroceria ?? "N/A"
      ],

      [
        "CILINDRAJE:",
        vehiculo.cilindraje ?? "N/A"
      ],

      [
        "# MOTOR:",
        vehiculo.numeroMotor ?? "N/A"
      ],

      [
        "# SERIE:",
        vehiculo.serie ?? "N/A"
      ],

      [
        "CHASIS:",
        vehiculo.chasis ?? "N/A"
      ],

      [
        "MATRÍCULA:",
        vehiculo.matricula ?? "N/A"
      ],

      [
        "ORGANISMO:",
        vehiculo.organismo ?? "N/A"
      ]

    ];


    // =======================================================
    // DIBUJAR INFORMACIÓN
    // =======================================================

    let x = 5;

    let idx = 0;

    const anchoColumna = 106;

    const labelWidth = 22;

    const valueWidth = 80;

    const altoMinimo = 6;


    while (
      idx < infoVehiculo.length
    ) {

      const campoIzq =
        infoVehiculo[idx];

      const campoDer =
        infoVehiculo[idx + 1];


      const alturaIzq =
        this.dibujarCampoVehiculoSimple(
          doc,
          x,
          y,
          campoIzq[0],
          campoIzq[1],
          labelWidth,
          valueWidth
        );


      let alturaDer =
        altoMinimo;


      if (campoDer) {

        alturaDer =
          this.dibujarCampoVehiculoSimple(
            doc,
            x + anchoColumna,
            y,
            campoDer[0],
            campoDer[1],
            labelWidth,
            valueWidth
          );
      }


      const alturaFila =
        Math.max(
          alturaIzq,
          alturaDer,
          altoMinimo
        );


      y += alturaFila;

      idx += 2;
    }


    // =======================================================
    // ESPACIO ANTES DE TABLA
    // =======================================================

    y += 8;


    // =======================================================
    // TABLA DE MANTENIMIENTOS
    //
    // IMPORTANTE:
    // Guardamos el Y que devuelve la función.
    // =======================================================
   // console.log(tiposMantenimiento);
    y = this.drawMantenimientosTable(
      doc,
      mantenimientos,     
      y
    );

    y = this.drawResumenTiposMantenimiento(doc, tiposMantenimiento, y);

    y = this.drawGraficaTiposMantenimiento(doc, tiposMantenimiento, y);
    // =======================================================
    // OBSERVACIONES
    //
    // Comienza EXACTAMENTE después de la tabla.
    // =======================================================

    y = this.drawObservaciones(
      doc,
      mantenimientos,
      y
    );


    // =======================================================
    // SIGUIENTE VEHÍCULO
    // =======================================================

    // El siguiente vehículo comenzará en una nueva página.
  }


  // =========================================================
  // FOOTER
  // =========================================================

  const totalPages =
    doc.getNumberOfPages();


  for (
    let p = 1;
    p <= totalPages;
    p++
  ) {

    doc.setPage(p);

    this.addFooter(
      doc,
      p,
      totalPages
    );
  }


  // =========================================================
  // MOSTRAR PDF
  // =========================================================

  const pdfBlob =
    doc.output("blob");


  const pdfUrl =
    URL.createObjectURL(
      pdfBlob
    );


  window.open(
    pdfUrl,
    "_blank"
  );

  this.toastTipo = 'success';
  this.mensajeToast = 'Documento generado con éxito';
  setTimeout(() => this.mostrandoToast = false, 2500);

  } catch (error) {
    console.error("Error generando la ficha de mantenimientos:", error);
    this.toastTipo = 'error';
    this.mensajeToast = 'No se pudo generar el documento';
    setTimeout(() => this.mostrandoToast = false, 3000);
  } finally {
    if (this.toastTipo === 'cargando') {
      this.mostrandoToast = false;
    }
  }
}
//

private dibujarCampoVehiculoSimple(
  doc: jsPDF,
  x: number,
  y: number,
  label: string,
  value: any,
  labelWidth: number = 22,
  valueWidth: number = 80
): number {

  const padding = 2;

  const fontSize = 7;

  const lineHeight = 3.5;

  const texto =
    String(value ?? "N/A").trim() ||
    "N/A";


  // =========================================================
  // CALCULAR LÍNEAS
  // =========================================================

  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.setFontSize(
    fontSize
  );

  const lineas =
    doc.splitTextToSize(
      texto,
      valueWidth - 4
    );


  const altura =
    Math.max(
      6,
      lineas.length * lineHeight + 2
    );


  // =========================================================
  // LABEL
  // =========================================================

  doc.setFillColor(
    240,
    240,
    240
  );

  doc.setDrawColor(
    180,
    180,
    180
  );

  doc.setLineWidth(
    0.2
  );

  doc.rect(
    x,
    y,
    labelWidth,
    altura,
    "FD"
  );


  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(
    fontSize
  );

  doc.setTextColor(
    0,
    0,
    0
  );

  doc.text(
    String(label ?? ""),
    x + padding,
    y + 4
  );


  // =========================================================
  // VALOR
  // =========================================================

  doc.setFillColor(
    255,
    255,
    255
  );

  doc.rect(
    x + labelWidth,
    y,
    valueWidth,
    altura,
    "FD"
  );


  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.text(
    lineas,
    x + labelWidth + padding,
    y + 4
  );


  return altura;
}

  drawDataTable(
    doc: jsPDF,
    data: { label: string; value: string }[],
    x: number,
    y: number
  ): number {
    const anchoLabel = 30;
    const anchoValue = 65;
    const anchoTotal = anchoLabel + anchoValue;
    const altoFila = 5;

    // Borde externo general
    const altoTotal = data.length * altoFila;
    doc.setDrawColor(0).setLineWidth(0.3);
    doc.rect(x, y, anchoTotal, altoTotal); // marco exterior

    data.forEach((item, i) => {
      const filaY = y + i * altoFila;

      // Fondo gris claro solo para la celda de la etiqueta
      doc.setFillColor(230, 230, 230);
      doc.rect(x, filaY, anchoLabel, altoFila, "F"); // fondo de la etiqueta

      // Líneas internas horizontales
      if (i < data.length) {
        doc.line(x, filaY, x + anchoTotal, filaY); // línea superior de cada fila
      }

      // Línea vertical de separación (opcional, ya está con rects)
      doc.line(x + anchoLabel, filaY, x + anchoLabel, filaY + altoFila);

      // Texto: etiqueta (negrita) y valor
      doc.setFontSize(7).setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(String(item.label), x + 2, filaY + 3.5);
      doc.setFont("helvetica", "bold");
      doc.text(String(item.value ?? "N/A"), x + anchoLabel + 2, filaY + 3.5);
    });

    return y + altoTotal;
  }

drawMantenimientosTable(
  doc: jsPDF,
  mantenimientos: any[],
  
  startY: number
): number {

  const columnas = [
    "FECHA",
    "CONCEPTO",
    "TALLER",
    "VR UNITARIO",
    "TIPO",
    "# DE FACTURA"
  ];

  // 206 mm en total
  const anchos = [18, 55, 58, 25, 25,25];

  const x = 5;
  const anchoTotal = anchos.reduce((a, b) => a + b, 0);

  const altoFilaMinimo = 6;

  // Límite inferior de la página
  const limitePagina = 265;

  let filaY = startY;
  let total = 0;

  // =========================================================
  // FUNCIÓN ENCABEZADO
  // =========================================================

  const drawHeader = () => {

    let xActual = x;

    columnas.forEach((col, i) => {

      const ancho = anchos[i];

      doc.setFillColor(220, 220, 220);
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.2);

      doc.rect(
        xActual,
        filaY,
        ancho,
        altoFilaMinimo,
        "FD"
      );

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(0, 0, 0);

      doc.text(
        col,
        xActual + ancho / 2,
        filaY + 4,
        {
          align: "center"
        }
      );

      xActual += ancho;
    });

    filaY += altoFilaMinimo;
  };


  // =========================================================
  // TÍTULO
  // =========================================================

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);

 doc.setFillColor(220, 220, 220);
  doc.setDrawColor(200);
  doc.setLineWidth(0.2);

  doc.rect(
    x,
    filaY - 5.5,
    anchoTotal,
    10,
    "FD"
  );
//listado de mantenimientos realizados con el rango de fechas especificado
  doc.text(
    "LISTADO DE MANTENIMIENTOS REALIZADOS",
    x + anchoTotal / 2,
    filaY - 1.6,
    {
      align: "center"
    }
  );

  filaY += 1;

  // Primer encabezado
  drawHeader();


  // =========================================================
  // MANTENIMIENTOS
  // =========================================================

  for (const m of mantenimientos) {

    // -------------------------------------------------------
    // VALOR
    // -------------------------------------------------------

    const vr =
      Number(
        String(m.vrpagos ?? "")
          .replace(/\./g, "")
          .replace(/,/g, ".")
      ) || 0;

    total += vr;


    // -------------------------------------------------------
    // VALORES
    // -------------------------------------------------------
    //console.log(m);
    //console.log("Tipo de mantenimiento:",tipoMantenimiento);
    const valores = [

      this.formatDateTodo(m.fecha),

      `${m.tipoServicio?.tipo_de_mantenimiento ?? "N/A"} (${m.id ?? ""})`,

      m.taller ?? "N/A",

      `$${vr.toLocaleString("es-CO")}`,
      m.tipoMantenimiento.nombre ?? "N/A",
      m.factura ?? "N/A"

    ];


    // -------------------------------------------------------
    // CALCULAR LÍNEAS
    // -------------------------------------------------------

    const lineasPorCelda: string[][] = [];

    let mayorCantidadLineas = 1;

    valores.forEach((val, i) => {

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      const lineas = doc.splitTextToSize(
        String(val),
        anchos[i] - 4
      );

      lineasPorCelda.push(lineas);

      mayorCantidadLineas = Math.max(
        mayorCantidadLineas,
        lineas.length
      );
    });


    // -------------------------------------------------------
    // ALTURA DINÁMICA
    // -------------------------------------------------------

    const altoFila = Math.max(
      altoFilaMinimo,
      mayorCantidadLineas * 3.5 + 2
    );


    // =======================================================
    // ¿CABE LA FILA EN LA PÁGINA?
    // =======================================================

    if (filaY + altoFila > limitePagina) {

      // Nueva página
      doc.addPage();

      // Reiniciar posición
      filaY = 15;

      // Repetir encabezado
      drawHeader();
    }


    // =======================================================
    // DIBUJAR FILA
    // =======================================================

    let xFila = x;

    const facturaColor: [number, number, number] =
      m.factura?.startsWith("1")
        ? [255, 0, 0]
        : [0, 150, 0];


    valores.forEach((val, i) => {

      const ancho = anchos[i];

      // -----------------------------------------------------
      // CELDA
      // -----------------------------------------------------

      doc.setFillColor(255, 255, 255);
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.2);

      doc.rect(
        xFila,
        filaY,
        ancho,
        altoFila,
        "FD"
      );


      // -----------------------------------------------------
      // ALINEACIÓN
      // -----------------------------------------------------

      const align: "left" | "center" =
        [0, 3, 4].includes(i)
          ? "center"
          : "left";


      const textX =
        align === "center"
          ? xFila + ancho / 2
          : xFila + 2;


      // -----------------------------------------------------
      // FACTURA
      // -----------------------------------------------------

      if (i === 5) {

        if (m.soporteUrl) {

          doc.setTextColor(0, 0, 255);

          doc.textWithLink(
            lineasPorCelda[i].join("\n"),
            textX,
            filaY + 4,
            {
              url: m.soporteUrl,
              align
            }
          );

        } else {

          doc.setTextColor(...facturaColor);

          doc.text(
            lineasPorCelda[i],
            textX,
            filaY + 4,
            {
              align
            }
          );
        }

      } else {

        doc.setTextColor(0, 0, 0);

        doc.text(
          lineasPorCelda[i],
          textX,
          filaY + 4,
          {
            align
          }
        );
      }


      xFila += ancho;

    });


    // -------------------------------------------------------
    // SIGUIENTE FILA
    // -------------------------------------------------------

    filaY += altoFila;
  }


  // =========================================================
  // TOTAL
  // =========================================================

  // Si el total no cabe, crear página
/*   if (filaY + 6 > limitePagina) {

    doc.addPage();

    filaY = 15;
  } */  
 
  filaY += 2;

  return filaY;
}


//resumen de tipos de mantenimientos realizados en el rango de fechas especificado
drawResumenTiposMantenimiento(
  doc: jsPDF,
  tiposMantenimiento: any[],
  startY: number
): number {

  const x = 5;
  const anchoPagina = doc.internal.pageSize.getWidth();
  const anchoTotal = anchoPagina - 10;
  const limitePagina = 270;

  const altoTitulo = 8;
  const altoEncabezado = 7;
  const altoFilaMinimo = 6;
  const altoLinea = 3.5;

  let y = startY;

  if (
    !Array.isArray(tiposMantenimiento) ||
    tiposMantenimiento.length === 0
  ) {
    return y;
  }

  // =====================================================
  // COLUMNAS
  // =====================================================

  const columnas = [
    "TIPO DE MANTENIMIENTO",
    "CANTIDAD",
    "COSTO TOTAL"
  ];

  const anchos = [
    120,
    35,
    51
  ];

  // =====================================================
  // FUNCIÓN PARA DIBUJAR ENCABEZADO DE COLUMNAS
  // =====================================================

  const dibujarEncabezado = (): void => {

    let xActual = x;

    columnas.forEach((columna, index) => {

      const ancho = anchos[index];

      // IMPORTANTE: fondo explícito
      doc.setFillColor(235, 235, 235);
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.2);

      doc.rect(
        xActual,
        y,
        ancho,
        altoEncabezado,
        "FD"
      );

      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(0, 0, 0);

      doc.text(
        columna,
        xActual + ancho / 2,
        y + 4.5,
        {
          align: "center"
        }
      );

      xActual += ancho;
    });

    y += altoEncabezado;
  };

  // =====================================================
  // TÍTULO
  // =====================================================

  if (
    y + altoTitulo + altoEncabezado >
    limitePagina
  ) {
    doc.addPage();
    y = 20;
  }

  // Fondo gris del título
  doc.setFillColor(220, 220, 220);
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.2);

  doc.rect(
    x,
    y,
    anchoTotal,
    altoTitulo,
    "FD"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(0, 0, 0);

  doc.text(
    "RESUMEN POR TIPO DE MANTENIMIENTO",
    x + anchoTotal / 2,
    y + 5.2,
    {
      align: "center"
    }
  );

  y += altoTitulo;

  dibujarEncabezado();

  // =====================================================
  // FILAS
  // =====================================================

  tiposMantenimiento.forEach((tipo: any) => {

    const nombreTipo =
      String(
        tipo?.tipo ??
        "SIN TIPO"
      ).trim();

    const cantidad =
      Number(tipo?.cantidad) || 0;

    const costoTotal =
      Number(tipo?.costoTotal) || 0;

    // -----------------------------------------------
    // TEXTO ENVUELTO
    // -----------------------------------------------

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);

    const lineasTipo =
      doc.splitTextToSize(
        nombreTipo,
        anchos[0] - 4
      );

    const altoFila =
      Math.max(
        altoFilaMinimo,
        lineasTipo.length * altoLinea + 2
      );

    // -----------------------------------------------
    // SALTO DE PÁGINA
    // -----------------------------------------------

    if (y + altoFila > limitePagina) {

      doc.addPage();

      y = 20;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);

      doc.text(
        "RESUMEN POR TIPO DE MANTENIMIENTO - CONTINUACIÓN",
        x,
        y
      );

      y += 5;

      dibujarEncabezado();
    }

    let xActual = x;

    // =================================================
    // COLUMNA 1 - TIPO
    // =================================================

    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.2);

    doc.rect(
      xActual,
      y,
      anchos[0],
      altoFila,
      "FD"
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0);

    doc.text(
      lineasTipo,
      xActual + 2,
      y + 4
    );

    xActual += anchos[0];

    // =================================================
    // COLUMNA 2 - CANTIDAD
    // =================================================

    // MUY IMPORTANTE:
    // volver a establecer fondo blanco
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.2);

    doc.rect(
      xActual,
      y,
      anchos[1],
      altoFila,
      "FD"
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0);

    doc.text(
      cantidad.toString(),
      xActual + anchos[1] / 2,
      y + 4,
      {
        align: "center"
      }
    );

    xActual += anchos[1];

    // =================================================
    // COLUMNA 3 - COSTO TOTAL
    // =================================================

    // MUY IMPORTANTE:
    // volver a establecer fondo blanco
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.2);

    doc.rect(
      xActual,
      y,
      anchos[2],
      altoFila,
      "FD"
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(0, 0, 0);

    doc.text(
      `$${costoTotal.toLocaleString("es-CO")}`,
      xActual + anchos[2] - 2,
      y + 4,
      {
        align: "right"
      }
    );

    y += altoFila;
  });

  // =====================================================
  // TOTALES
  // =====================================================

  const totalCantidad =
    tiposMantenimiento.reduce(
      (total: number, tipo: any) =>
        total +
        (Number(tipo?.cantidad) || 0),
      0
    );

  const totalCosto =
    tiposMantenimiento.reduce(
      (total: number, tipo: any) =>
        total +
        (Number(tipo?.costoTotal) || 0),
      0
    );

  const altoTotal = 7;

  if (y + altoTotal > limitePagina) {

    doc.addPage();

    y = 20;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);

    doc.text(
      "RESUMEN POR TIPO DE MANTENIMIENTO - CONTINUACIÓN",
      x,
      y
    );

    y += 5;

    dibujarEncabezado();
  }

  let xActual = x;

  // =====================================================
  // TOTAL - TIPO
  // =====================================================

  doc.setFillColor(235, 235, 235);
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.2);

  doc.rect(
    xActual,
    y,
    anchos[0],
    altoTotal,
    "FD"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(0, 0, 0);

  doc.text(
    "TOTAL",
    xActual + anchos[0] - 2,
    y + 4.5,
    {
      align: "right"
    }
  );

  xActual += anchos[0];

  // =====================================================
  // TOTAL - CANTIDAD
  // =====================================================

  doc.setFillColor(235, 235, 235);
  doc.setDrawColor(180, 180, 180);

  doc.rect(
    xActual,
    y,
    anchos[1],
    altoTotal,
    "FD"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(0, 0, 0);

  doc.text(
    totalCantidad.toString(),
    xActual + anchos[1] / 2,
    y + 4.5,
    {
      align: "center"
    }
  );

  xActual += anchos[1];

  // =====================================================
  // TOTAL - COSTO
  // =====================================================

  doc.setFillColor(235, 235, 235);
  doc.setDrawColor(180, 180, 180);

  doc.rect(
    xActual,
    y,
    anchos[2],
    altoTotal,
    "FD"
  );

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(0, 0, 0);

  doc.text(
    `$${totalCosto.toLocaleString("es-CO")}`,
    xActual + anchos[2] - 2,
    y + 4.5,
    {
      align: "right"
    }
  );

  y += altoTotal + 8;

  return y;
}


//grafico de tipos de mantenimientos realizados en el rango de fechas especificado
drawGraficaTiposMantenimiento(
  doc: jsPDF,
  tiposMantenimiento: any[],
  startY: number
): number {

  const x = 5;

  const anchoPagina =
    doc.internal.pageSize.getWidth();

  const anchoTotal =
    anchoPagina - 10;

  const limitePagina = 270;

  let y = startY;

  // =====================================================
  // VALIDAR DATOS
  // =====================================================

  if (
    !Array.isArray(tiposMantenimiento) ||
    tiposMantenimiento.length === 0
  ) {
    return y;
  }

  // =====================================================
  // COLORES POR CÓDIGO
  // =====================================================

  const coloresTipos: {
    [key: string]: [number, number, number]
  } = {

    // PREVENTIVO
    "PRE": [40, 167, 69],

    // PREDICTIVO
    "PRED": [0, 123, 255],

    // CORRECTIVO
    "CORR": [220, 53, 69],

    // CORRECTIVO Y PREVENTIVO
    "COP": [255, 152, 0],

    // PREDICTIVO Y PREVENTIVO
    "PYP": [111, 66, 193],

    // EMERGENCIA
    "EMER": [80, 80, 80]
  };

  const colorDefault: [number, number, number] =
    [150, 150, 150];

  // =====================================================
  // NORMALIZAR DATOS
  // =====================================================

  const datos = tiposMantenimiento
    .map((item: any) => ({

      codigo: String(
        item?.codigo ??
        ""
      )
        .trim()
        .toUpperCase(),

      tipo: String(
        item?.tipo ??
        "SIN TIPO"
      ).trim(),

      cantidad:
        Number(item?.cantidad) || 0,

      costoTotal:
        Number(item?.costoTotal) || 0

    }))
    .filter(
      (item) =>
        item.cantidad > 0
    );

  if (!datos.length) {
    return y;
  }

  // =====================================================
  // ORDENAR MAYOR A MENOR
  // =====================================================

  datos.sort(
    (a, b) =>
      b.cantidad -
      a.cantidad
  );

  // =====================================================
  // TOTAL
  // =====================================================

  const totalCantidad =
    datos.reduce(
      (
        total: number,
        dato: any
      ) =>
        total +
        dato.cantidad,
      0
    );

  // =====================================================
  // DIMENSIONES
  // =====================================================

  const altoTitulo = 8;
  const altoFila = 10;

  const anchoEtiqueta = 65;
  const anchoGrafica = 110;

  const altoGrafica =
    altoTitulo +
    1 +
    datos.length *
      altoFila +
    8;

  // =====================================================
  // SALTO DE PÁGINA
  // =====================================================

  if (
    y + altoGrafica >
    limitePagina
  ) {

    doc.addPage();

    y = 15;
  }

  // =====================================================
  // TÍTULO
  // =====================================================

  doc.setFillColor(
    220,
    220,
    220
  );

  doc.setDrawColor(
    180,
    180,
    180
  );

  doc.setLineWidth(0.2);

  doc.rect(
    x,
    y,
    anchoTotal,
    altoTitulo,
    "FD"
  );

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(8);

  doc.setTextColor(
    0,
    0,
    0
  );

  doc.text(
    "GRÁFICA DE MANTENIMIENTOS POR TIPO DE MANTENIMIENTO",
    x + anchoTotal / 2,
    y + 5.2,
    {
      align: "center"
    }
  );

  y +=
    altoTitulo +
    6;

  // =====================================================
  // VALOR MÁXIMO
  // =====================================================

  const maxCantidad =
    Math.max(
      ...datos.map(
        (item) =>
          item.cantidad
      )
    );

  // =====================================================
  // BARRAS
  // =====================================================

  datos.forEach(
    (item: any) => {

      // -----------------------------------------------
      // COLOR DEL TIPO
      // -----------------------------------------------

      const colorBarra =
        coloresTipos[
          item.codigo
        ] ??
        colorDefault;

      // -----------------------------------------------
      // ETIQUETA
      // -----------------------------------------------

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(6.5);

      doc.setTextColor(
        0,
        0,
        0
      );

      const lineasTipo =
        doc.splitTextToSize(
          item.tipo,
          anchoEtiqueta - 3
        );

      doc.text(
        lineasTipo,
        x,
        y + 4
      );

      // -----------------------------------------------
      // POSICIÓN BARRA
      // -----------------------------------------------

      const xBarra =
        x +
        anchoEtiqueta;

      const yBarra =
        y + 1;

      const altoBarra = 6;

      // -----------------------------------------------
      // FONDO DE LA BARRA
      // -----------------------------------------------

      doc.setFillColor(
        240,
        240,
        240
      );

      doc.setDrawColor(
        210,
        210,
        210
      );

      doc.rect(
        xBarra,
        yBarra,
        anchoGrafica,
        altoBarra,
        "FD"
      );

      // -----------------------------------------------
      // PORCENTAJE RELATIVO AL MÁXIMO
      // -----------------------------------------------

      const porcentaje =
        maxCantidad > 0
          ? item.cantidad /
            maxCantidad
          : 0;

      const largoBarra =
        Math.max(
          2,
          porcentaje *
            anchoGrafica
        );

      // -----------------------------------------------
      // BARRA CON COLOR
      // -----------------------------------------------

      doc.setFillColor(
        colorBarra[0],
        colorBarra[1],
        colorBarra[2]
      );

      doc.setDrawColor(
        colorBarra[0],
        colorBarra[1],
        colorBarra[2]
      );

      doc.rect(
        xBarra,
        yBarra,
        largoBarra,
        altoBarra,
        "F"
      );

      // -----------------------------------------------
      // CANTIDAD
      // -----------------------------------------------

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.setFontSize(7);

      doc.setTextColor(
        0,
        0,
        0
      );

      doc.text(
        item.cantidad.toString(),
        xBarra +
          anchoGrafica +
          4,
        y + 5
      );

      // -----------------------------------------------
      // PORCENTAJE DEL TOTAL
      // -----------------------------------------------

      const porcentajeTipo =
        totalCantidad > 0
          ? (
              item.cantidad /
              totalCantidad
            ) * 100
          : 0;

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(6);

      doc.text(
        `${porcentajeTipo.toFixed(1)}%`,
        xBarra +
          anchoGrafica +
          13,
        y + 5
      );

      // -----------------------------------------------
      // SIGUIENTE FILA
      // -----------------------------------------------

      y += altoFila;
    }
  );

  // =====================================================
  // TOTAL
  // =====================================================

  y += 2;

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(7);

  doc.setTextColor(
    0,
    0,
    0
  );

  doc.text(
    `TOTAL DE MANTENIMIENTOS: ${totalCantidad}`,
    x,
    y
  );

  return y + 8;
}

private drawObservaciones(
  doc: jsPDF,
  mantenimientos: any[],
  startY: number
): number {

  const x = 5;

  const anchoPagina =
    doc.internal.pageSize.getWidth();

  const anchoTotal =
    anchoPagina - 10;

  const limitePagina = 270;

  const altoLinea = 3.5;

  const espacioEntreObservaciones = 3;

  let y = startY;

  // =====================================================
  // SOLO OBSERVACIONES CON INFORMACIÓN
  // =====================================================

  const observaciones =
    mantenimientos.filter(
      (m: any) =>
        m?.observacion !== null &&
        m?.observacion !== undefined &&
        String(m.observacion).trim() !== ""
    );

  if (!observaciones.length) {
    return y;
  }

  // =====================================================
  // FUNCIÓN TÍTULO
  // =====================================================

  const dibujarTitulo = (
    titulo: string
  ): void => {

    const altoTitulo = 8;

    // Fondo
    doc.setFillColor(
      220,
      220,
      220
    );

    doc.setDrawColor(
      180,
      180,
      180
    );

    doc.setLineWidth(0.2);

    doc.rect(
      x,
      y,
      anchoTotal,
      altoTitulo,
      "FD"
    );

    // Texto
    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(8);

    doc.setTextColor(
      0,
      0,
      0
    );

    doc.text(
      titulo,
      x + 3,
      y + 5.2
    );

    y += altoTitulo + 4;
  };

  // =====================================================
  // VERIFICAR ESPACIO PARA TÍTULO
  // =====================================================

  if (
    y + 15 >
    limitePagina
  ) {

    doc.addPage();

    y = 20;
  }

  dibujarTitulo(
    "OBSERVACIONES"
  );

  // =====================================================
  // OBSERVACIONES
  // =====================================================

  observaciones.forEach(
    (m: any, index: number) => {

      const id =
        m?.id ?? "";

      const observacion =
        String(
          m.observacion
        ).trim();

      // =================================================
      // TEXTO
      // =================================================

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(7);

      const anchoTexto =
        anchoTotal - 10;

      const lineas =
        doc.splitTextToSize(
          observacion,
          anchoTexto
        );

      const alturaTexto =
        lineas.length *
        altoLinea;

      const altoCabecera = 6;

      const altoCaja =
        altoCabecera +
        alturaTexto +
        5;

      // =================================================
      // SALTO DE PÁGINA
      // =================================================

      if (
        y + altoCaja >
        limitePagina
      ) {

        doc.addPage();

        y = 20;

        dibujarTitulo(
          "OBSERVACIONES - CONTINUACIÓN"
        );
      }

      // =================================================
      // CAJA PRINCIPAL
      // =================================================

      doc.setFillColor(
        250,
        250,
        250
      );

      doc.setDrawColor(
        185,
        185,
        185
      );

      doc.setLineWidth(
        0.25
      );

      doc.rect(
        x,
        y,
        anchoTotal,
        altoCaja,
        "FD"
      );

      // =================================================
      // CABECERA DE LA OBSERVACIÓN
      // =================================================

      doc.setFillColor(
        238,
        238,
        238
      );

      doc.rect(
        x,
        y,
        anchoTotal,
        altoCabecera,
        "F"
      );

      // Línea inferior cabecera
      doc.setDrawColor(
        205,
        205,
        205
      );

      doc.line(
        x,
        y + altoCabecera,
        x + anchoTotal,
        y + altoCabecera
      );

      // =================================================
      // ID
      // =================================================

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.setFontSize(6.5);

      doc.setTextColor(
        80,
        80,
        80
      );

      doc.text(
        `MANTENIMIENTO #${id}`,
        x + 3,
        y + 4
      );

      // =================================================
      // TEXTO OBSERVACIÓN
      // =================================================

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.setFontSize(7);

      doc.setTextColor(
        30,
        30,
        30
      );

      doc.text(
        lineas,
        x + 5,
        y +
          altoCabecera +
          4
      );

      // =================================================
      // SIGUIENTE
      // =================================================

      y +=
        altoCaja +
        espacioEntreObservaciones;
    }
  );

  return y + 3;
}
  formatDateTodo(fecha: any): string {
    if (!fecha) return "N/A";
    
    // Parse date string directly to avoid timezone issues
    const fechaStr = String(fecha).split('T')[0]; // Get only YYYY-MM-DD part
    const [year, month, day] = fechaStr.split('-');
    
    if (!year || !month || !day) return "N/A";
    
    return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
  }

  private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
      //  console.log(data);
        this.administraciones = data;       
        
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;  
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }

 getBadgeTipoMantenimiento(tipo?: string): string {

  if (!tipo) {
    return 'bg-secondary';
  }

  switch (tipo.toLowerCase().trim()) {

    case 'preventivo':
      return 'bg-success';

    case 'correctivo':
      return 'bg-danger';

    case 'predictivo':
      return 'bg-info';

    case 'programado':
      return 'bg-primary';

    case 'emergencia':
      return 'bg-warning text-dark';

    default:
      return 'bg-secondary';
  }
}

resumenMantenimiento = {
  total: 0,
  costoTotal: 0,
  costoPromedio: 0,
  cantidadVehiculos: 0
};

calcularResumenMantenimientos(mantenimientos: any[]): void {
  if (!mantenimientos || mantenimientos.length === 0) {
    this.estadisticasMantenimientos = {
      cantidadMantenimientos: 0,
      cantidadVehiculos: 0,
      costoTotal: 0,
      costoPromedio: 0
    };

    return;
  }

  // Cantidad total de mantenimientos
  const cantidadMantenimientos = mantenimientos.length;

  // Vehículos únicos
  const placasUnicas = new Set(
    mantenimientos
      .map(m => m.placa?.toString().trim().toUpperCase())
      .filter(Boolean)
  );

  const cantidadVehiculos = placasUnicas.size;

  // Costo total
  const costoTotal = mantenimientos.reduce(
    (total, mantenimiento) => {
      const valor = Number(mantenimiento.vrpagos) || 0;
      return total + valor;
    },
    0
  );

  // Costo promedio por mantenimiento
  const costoPromedio =
    cantidadMantenimientos > 0
      ? costoTotal / cantidadMantenimientos
      : 0;

  // Guardar resumen
  this.estadisticasMantenimientos = {
    cantidadMantenimientos,
    cantidadVehiculos,
    costoTotal,
    costoPromedio
  };
}

}

